module.exports = __webpack_public_path__ + "img/setting.f61a838b.svg";